import { LACK_OF_OPTIONS } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { ListService } from "@/modules/List/services/ListService";
import {
  MULTIMEDIA_ACCESS,
  MULTIMEDIA_CONSTANTS,
  MULTIMEDIA_ICONS_FILE_TYPE,
  NEW_FILE,
  TYPE_FILES
} from "@/modules/Multimedia/constants/multimediaConstants";
import { MultimediaQuery } from "@/modules/Multimedia/models/MultimediaQuery.model";
import { MulimediaResponse } from "@/modules/Multimedia/models/MultimediaResponse";
import { MultimediaService } from "@/modules/Multimedia/services/MultimediaService";
import {
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import {
  SNACKBAR_STYLE,
  STYLE_CLASSES
} from "@/shared/constants/StyleConstants";
import { Http } from "@status/codes";
import { Vue, Component, Inject, Watch, Prop } from "vue-property-decorator";
import { List } from "../GenericSearchBar/model/List";
import Snackbar from "../Snackbar/Snackbar";
import { Response } from "@/shared/models/Response";
import { MultimediaDTO } from "@/modules/Multimedia/models/Multimedia.model";
import DocumentViewer from "@/shared/components/DocumentViewer/DocumentViewer.vue";
import { MultimediaSelected } from "./models/MultimediaSelected.model";
import { MULTIMEDIA_MANAGER_CONSTANTS } from "./constants/MultimediaManagerConstants";
import { LIST_ACCESS } from "@/modules/List/constants/ListConstants";
import { GENERAL_CONSTANTS } from "@/shared/constants/GeneralConstants";
import DynamicSelect from "../DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "../DynamicSelect/model/DynamicSelectConfig";

@Component({
  name: "MultimediaManager",
  components: { DocumentViewer, DynamicSelect }
})
export default class MultimediaManager extends Vue {
  @Inject() listService!: ListService;
  @Inject() multimediaService!: MultimediaService;

  @Prop() multimediaToEdit!: MultimediaSelected;
  @Prop() isToEdit!: boolean;
  @Prop() required!: boolean;

  multimediaSelectedForm = false;
  changeForm = false;
  multimediaModal = false;
  cardClass = STYLE_CLASSES.CARD;
  priBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  categories: List[] = [];
  MULTIMEDIA_MANAGER_CONSTANTS = MULTIMEDIA_MANAGER_CONSTANTS;
  typesFiles = TYPE_FILES;
  filesList: Array<MultimediaDTO> = [];
  filterQuery: MultimediaQuery = {};
  requiredField = [FORM_VALIDATORS.REQUIRED_FIELD];
  requiredArrayFields = [FORM_VALIDATORS.REQUIRED_MULTIMEDIA_OBJECT];
  showModaViewFile = false;
  multimediaFile: MultimediaDTO = { ...NEW_FILE };
  MultimediaFileViewer = { ...NEW_FILE };
  INACTIVE_ELEMENT: string = SNACKBAR_STYLE.WARNING.COLOR;

  fileTypeConfigList: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: this.typesFiles.map(item => {
      return { id: item.key, name: item.name };
    }),
    messageLabel: this.MULTIMEDIA_MANAGER_CONSTANTS.TYPE,
    hint: "",
    persistenthint: false,
    required: false,
    chips: true
  };
  fileTypeModel = [{ id: "", name: "" }];

  fileCategoryConfigList: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: [],
    messageLabel: this.MULTIMEDIA_MANAGER_CONSTANTS.CATEGORY,
    hint: "",
    persistenthint: false,
    required: false,
    chips: true
  };
  fileCategoryModel = [{ id: "", name: "" }];

  multimediaFileConfigList: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: [],
    messageLabel: this.MULTIMEDIA_MANAGER_CONSTANTS.SELECT_FILE,
    hint: "",
    persistenthint: false,
    required: this.required,
    chips: true,
    loadingData: true,
    attach: true
  };
  multimediaFileModel = [{ id: "", name: "" }];
  lastRef = "";

  async mounted() {
    await this.getCategoryListMultimedia();
  }

  get fileType() {
    return this.fileTypeModel[0];
  }
  set fileType(data: { id: string; name: string }) {
    this.fileTypeModel = [data];
  }
  get fileCategory() {
    return this.fileCategoryModel[0];
  }
  set fileCategory(data: { id: string; name: string }) {
    this.fileCategoryModel = [data];
  }

  @Watch("multimediaToEdit._key")
  async preloadForm(search = true) {
    if (!this.isToEdit && this.multimediaToEdit._key === "") {
      this.cleanForm();
      this.filesList = [];
      return;
    }

    if (Object.keys(this.multimediaToEdit).length === 1) {
      this.fillForm(this.multimediaFile);
    } else {
      this.fillForm(this.multimediaToEdit);

      if (search) {
        this.loadInactiveFile();
      }
    }
    this.findFileInList();
  }

  get fileName() {
    return this.multimediaToEdit?._key ? this.multimediaToEdit?.name : "";
  }

  cleanForm(emit = false) {
    this.multimediaFile = { ...NEW_FILE };
    this.fileTypeModel = [{ id: "", name: "" }];
    this.fileCategoryModel = [{ id: "", name: "" }];
    if (emit)
      this.$emit(MULTIMEDIA_MANAGER_CONSTANTS.SEND_FILE, this.multimediaFile);
  }

  fillForm(multimediaFileToFillForm: MultimediaDTO | MultimediaSelected) {
    const type = this.typesFiles.find(
      item => item.key === multimediaFileToFillForm.type
    );
    const category = this.categories.find(
      item => item.key === multimediaFileToFillForm.category
    );

    this.fileType = { id: type?.key ?? "", name: type?.name ?? "" };
    this.fileCategory = { id: category?.key ?? "", name: category?.name ?? "" };
  }

  findFileInList() {
    const fileInList = this.filesList.find(
      item => item._key === this.multimediaToEdit._key
    );
    this.multimediaFile = fileInList ? fileInList : { ...NEW_FILE };
    this.multimediaFileModel = [
      {
        id: fileInList?._key ?? "",
        name: fileInList?.name ?? ""
      }
    ];
  }

  async getCategoryListMultimedia() {
    const responseData = await this.getListDataById(
      MULTIMEDIA_CONSTANTS.CATEGORY_MULTIMEDIA_ID
    );
    this.categories = responseData !== undefined ? responseData : [];
    this.fileCategoryConfigList.listAll = this.categories.map(item => {
      return { id: item.key, name: item.name };
    });
    if (this.multimediaToEdit._key) {
      this.preloadForm(true);
    }
  }

  async getListDataById(id: string) {
    try {
      const responseData = await this.listService.getListById(id);
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        const listDataList: List[] = [];
        const dataList = responseData.data.optionsSchema as {
          title: string;
        }[];
        dataList.forEach(a =>
          listDataList.push({ key: a.title, name: a.title })
        );

        return listDataList;
      } else {
        Snackbar.popInfo(LACK_OF_OPTIONS);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${LIST_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async handleFiles(name: string) {
    this.multimediaFileConfigList.loadingData = true;
    this.multimediaFileConfigList.notFound = false;
    const response: Response<MulimediaResponse> = await this.multimediaService.getFilesByFilters(
      { name }
    );

    if (response.code === Http.Found && response.data) {
      this.filesList = [...this.filesList, ...response.data.multimediaList];
      this.filesList = this.filesList.filter(item => {
        if (
          item.category === this.fileCategoryModel[0].id &&
          item.type === this.fileTypeModel[0].id
        ) {
          return item;
        }
      });
    } else {
      this.multimediaFileConfigList.notFound = true;
    }
    this.multimediaFileConfigList.loadingData = false;
  }

  async findFiles(clearReference = false, name?: string) {
    if (name && (this.filterQuery.type || this.filterQuery.category)) {
      this.handleFiles(name);
      return;
    }
    this.multimediaFileConfigList.loadingData = true;
    if (clearReference) this.lastRef = "";
    if (this.fileType && this.fileType.id)
      this.filterQuery.type = [this.fileType.id];
    if (this.fileCategory && this.fileCategory.id)
      this.filterQuery.category = [this.fileCategory.id];

    this.filterQuery.state = [true];
    this.filterQuery.getChartInfo = false;
    this.filterQuery.paginateResult = true;
    this.filterQuery.lastReference = this.lastRef;
    this.multimediaFile = { ...NEW_FILE };

    if (this.filterQuery.type || this.filterQuery.category) {
      try {
        const response: Response<MulimediaResponse> = await this.multimediaService.getFilesByFilters(
          this.filterQuery
        );

        if (response.code === Http.Found && response.data !== undefined) {
          if (this.lastRef) {
            this.filesList = [
              ...this.filesList,
              ...response.data.multimediaList
            ];
            this.filesList = this.filesList.filter(item => {
              if (
                item.category === this.fileCategoryModel[0].id &&
                item.type === this.fileTypeModel[0].id
              ) {
                return item;
              }
            });
          } else {
            this.filesList = response.data.multimediaList;
            this.filesList = this.filesList.filter(item => {
              if (
                item.category === this.fileCategoryModel[0].id &&
                item.type === this.fileTypeModel[0].id
              ) {
                return item;
              }
            });
          }

          this.lastRef = response.data.lastReference;

          const multimediaFileExist = this.filesList.find(
            item => item.name == this.multimediaFileModel[0].name
          );
          if (
            !multimediaFileExist &&
            this.fileTypeModel[0].id === this.multimediaToEdit.type
          ) {
            await this.handleFiles(this.multimediaFileModel[0].name);
          }
        } else {
          this.multimediaFileConfigList.notFound = true;
          if (this.multimediaFileConfigList.listAll.length <= 0) {
            Snackbar.popInfo(
              MULTIMEDIA_MANAGER_CONSTANTS.NO_FOUND_FILES_MESSAGES
            );
          }
        }
        this.multimediaFileConfigList.loadingData = false;
      } catch (error) {
        const errorMessage =
          (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
            ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${MULTIMEDIA_ACCESS.GET}`
            : FORM_MESSAGES.REQUEST_FAILED;

        Snackbar.popError(errorMessage);
      }
    } else {
      this.filesList = [];
    }
  }

  chargeData() {
    if (this.multimediaToEdit._key) {
      const index = this.multimediaFileConfigList.listAll.findIndex(
        file => file.id === this.multimediaToEdit._key
      );
      if (index != -1) {
        const fileSelect = this.multimediaFileConfigList.listAll[index];
        this.multimediaFileModel = [
          { id: fileSelect.id, name: fileSelect.name }
        ];
      } else {
        this.filesList = [
          {
            _key: this.multimediaToEdit._key,
            category: this.multimediaToEdit.category,
            fieldName: this.multimediaToEdit.fieldName ?? "",
            multimediaPath: this.multimediaToEdit.multimediaPath ?? "",
            name: this.multimediaToEdit.name ?? "",
            type: this.multimediaToEdit.type,
            state: true,
            fieldSize: ""
          }
        ];
        this.multimediaFileModel = [
          {
            id: this.multimediaToEdit._key!,
            name: this.multimediaToEdit.name!
          }
        ];
      }
    }
  }
  openModal() {
    this.chargeData();
    this.multimediaModal = true;
  }

  async cancel() {
    if (!this.changeForm) {
      this.multimediaFileModel = [{ id: "", name: "" }];
      this.multimediaModal = false;
      this.cleanForm(true);
      this.preloadForm(false);
      return;
    }
    this.multimediaModal = false;
  }

  get multimediaFileRef() {
    return this.multimediaFile ?? { ...NEW_FILE };
  }

  save() {
    const file: MultimediaSelected = {
      _key: this.multimediaFileRef._key!,
      category: this.multimediaFileRef.category,
      fieldName: this.multimediaFileRef.fieldName,
      multimediaPath: this.multimediaFileRef.multimediaPath,
      name: this.multimediaFileRef.name,
      type: this.multimediaFileRef.type
    };

    this.$emit(MULTIMEDIA_MANAGER_CONSTANTS.SEND_FILE, file);
    this.multimediaModal = false;
  }

  closePreview() {
    this.showModaViewFile = false;
  }

  viewFile(multimediaFileToViewer: MultimediaDTO | MultimediaSelected) {
    this.MultimediaFileViewer.fieldName =
      multimediaFileToViewer?.fieldName ?? "";
    this.MultimediaFileViewer.multimediaPath =
      multimediaFileToViewer?.multimediaPath ?? "";
    if (this.MultimediaFileViewer.multimediaPath) {
      this.showModaViewFile = true;
    }
  }

  loadInactiveFile() {
    if (this.isToEdit) {
      const response = this.filesList.find(
        file => file._key === this.multimediaToEdit._key
      );
      if (!response) {
        this.multimediaToEdit.state = false;
        this.filesList.push(
          (this.multimediaToEdit as unknown) as MultimediaDTO
        );
      }
    }
  }

  @Watch("filesList")
  setFileListConfig() {
    if (
      this.filesList.length > 0 &&
      this.fileType.id !== "" &&
      this.fileCategory.id !== ""
    ) {
      this.changeForm = true;
      this.multimediaFileConfigList.listAll = this.filesList.map(item => {
        return {
          id: item._key!,
          name: item.name,
          state: item.state == false ? FORM_CONSTANTS.STATE.INACTIVE : ""
        };
      });
      return;
    }

    this.multimediaFileConfigList.listAll = [];
  }

  get textFieldClass(): string {
    if (this.multimediaToEdit?._key) {
      return STYLE_CLASSES.TEXT_FIELD;
    } else {
      return (
        STYLE_CLASSES.TEXT_FIELD +
        MULTIMEDIA_MANAGER_CONSTANTS.DISABLED_VIEW_ICON
      );
    }
  }

  @Watch("multimediaFileModel", { deep: true })
  setMultimediaFile() {
    this.multimediaFile = this.filesList.find(
      item => item._key == this.multimediaFileModel[0].id
    ) ?? { ...NEW_FILE };
  }

  @Watch("fileCategoryModel", { deep: true })
  onChangeFileCategory() {
    if (this.multimediaToEdit.category != this.fileCategory.id) {
      this.multimediaFileModel = [{ id: "", name: "" }];
      this.multimediaFileConfigList.listAll = [];
    }
  }

  @Watch("fileTypeModel", { deep: true })
  onChangeFileType() {
    if (this.multimediaToEdit.type != this.fileType.id) {
      this.multimediaFileModel = [{ id: "", name: "" }];
      this.fileCategoryModel = [{ id: "", name: "" }];
    }
  }

  get appendIconMediaFile(): string {
    if (this.fileType.id == MULTIMEDIA_CONSTANTS.AUDIO_FILE) {
      return MULTIMEDIA_ICONS_FILE_TYPE.AUDIO;
    }
    return MULTIMEDIA_ICONS_FILE_TYPE.IMAGEN;
  }
}
